// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModernCard {
  background-color: #e6f7ef;
  border-radius: 20px;
  padding: 8px;
  display: flex;
  box-shadow: 0px 6px 16px 0px rgba(0, 170, 116, 0.1882352941);
  color: #333333;
}
.ModernCard .header {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.ModernCard .heading {
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0em;
}
.ModernCard .subheading {
  color: #00aa74;
  font-size: 26px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0.02em;
}
.ModernCard .icon {
  align-self: end;
  width: 30%;
  height: 50%;
}
.ModernCard .icon1 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
}
.ModernCard .icon1 img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.ModernCard .header-flex {
  display: flex;
  justify-content: space-between;
}
.ModernCard .header-flex-around {
  display: flex;
  justify-content: space-around;
}
.ModernCard .subheading-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.ModernCard .subheading-wrapper {
  width: 50%;
}

.modern-custom-class {
  background: #e6f7ef;
}

.HomeView--treeIcon {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 2rem;
  background: linear-gradient(225deg, #bae897 0%, #bbfbdd 100%);
}

@media (min-height: 600px) {
  .ModernCard {
    padding: 4px;
    border-radius: 12px;
    height: 125px;
    display: flex;
  }
  .ModernCard .header {
    gap: 12px;
  }
  .ModernCard .heading {
    font-size: 13px;
    line-height: 14px;
    width: "50%";
  }
  .ModernCard .subheading {
    font-size: 18px;
    line-height: 22px;
  }
  .ModernCard .icon1 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
  }
  .ModernCard .icon1 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .ModernCard .icon {
    width: 40%;
    height: 60%;
  }
  .ModernCard .icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
@media (min-height: 700px) {
  .ModernCard {
    padding: 4px;
    border-radius: 12px;
    height: 145px;
    display: flex;
  }
  .ModernCard .header {
    gap: 12px;
  }
  .ModernCard .heading {
    font-size: 13px;
    line-height: 14px;
    width: "50%";
  }
  .ModernCard .subheading {
    font-size: 18px;
    line-height: 22px;
  }
  .ModernCard .icon1 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
  }
  .ModernCard .icon1 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .ModernCard .icon {
    width: 45%;
    height: 65%;
  }
  .ModernCard .icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
@media (min-height: 800px) {
  .ModernCard {
    padding: 4px;
    border-radius: 12px;
    height: 180px;
    display: flex;
  }
  .ModernCard .header {
    gap: 12px;
  }
  .ModernCard .heading {
    font-size: 14px;
    line-height: 14px;
    width: "50%";
  }
  .ModernCard .subheading {
    font-size: 20px;
    line-height: 22px;
  }
  .ModernCard .icon1 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
  }
  .ModernCard .icon1 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .ModernCard .icon {
    width: 40%;
    height: 60%;
  }
  .ModernCard .icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
@media screen and (min-width: 400px) and (min-height: 800px) {
  .ModernCard {
    padding: 4px;
    border-radius: 12px;
    height: 207px;
    display: flex;
  }
  .ModernCard .header {
    gap: 12px;
  }
  .ModernCard .heading {
    font-size: 16px;
    line-height: 18px;
    width: "50%";
  }
  .ModernCard .subheading {
    font-size: 22px;
    line-height: 24px;
  }
  .ModernCard .icon1 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70px;
    height: 70px;
  }
  .ModernCard .icon1 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .ModernCard .icon {
    width: 40%;
    height: 70%;
  }
  .ModernCard .icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
@media screen and (min-width: 420px) and (min-height: 900px) {
  .ModernCard {
    padding: 4px;
    border-radius: 12px;
    height: 225px;
    display: flex;
  }
  .ModernCard .header {
    gap: 12px;
  }
  .ModernCard .heading {
    font-size: 18px;
    line-height: 20px;
    width: "50%";
  }
  .ModernCard .subheading {
    font-size: 24px;
    line-height: 26px;
  }
  .ModernCard .icon1 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
  }
  .ModernCard .icon1 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .ModernCard .icon {
    width: 40%;
    height: 80%;
  }
  .ModernCard .icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
@media screen and (max-width: 420px) and (min-height: 900px) {
  .ModernCard {
    padding: 4px;
    border-radius: 12px;
    height: 217px;
    display: flex;
  }
  .ModernCard .header {
    gap: 12px;
  }
  .ModernCard .heading {
    font-size: 18px;
    line-height: 20px;
    width: "50%";
  }
  .ModernCard .subheading {
    font-size: 24px;
    line-height: 26px;
  }
  .ModernCard .icon1 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 75px;
    height: 75px;
  }
  .ModernCard .icon1 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .ModernCard .icon {
    width: 40%;
    height: 80%;
  }
  .ModernCard .icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomeCards/ModernCard/ModernCard.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AAEA;EACI,yBCDY;EDEZ,mBAAA;EACA,YAAA;EACA,aAAA;EACA,4DAAA;EACA,cCcc;ADflB;AAEI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAAR;AAGI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AADR;AAGI;EACI,eAAA;EACA,UAAA;EACA,WAAA;AADR;AAII;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAFR;AAIQ;EACI,WAAA;EACA,YAAA;EAEA,mBAAA;AAHZ;AAMI;EACI,aAAA;EACA,8BAAA;AAJR;AAMI;EACI,aAAA;EACA,6BAAA;AAJR;AAOI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AALR;AAQI;EACI,UAAA;AANR;;AAUA;EACI,mBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,6DAAA;AAPJ;;AASA;EACI;IACI,YAAA;IACA,mBAAA;IACA,aAAA;IACA,aAAA;EANN;EAOM;IACI,SAAA;EALV;EAOM;IACI,eAAA;IACA,iBAAA;IACA,YAAA;EALV;EAOM;IACI,eAAA;IACA,iBAAA;EALV;EAOM;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;EALV;EAMU;IACI,WAAA;IACA,YAAA;IAEA,mBAAA;EALd;EAQM;IACI,UAAA;IACA,WAAA;EANV;EAQU;IACI,WAAA;IACA,YAAA;IACA,mBAAA;EANd;AACF;AAUA;EACI;IACI,YAAA;IACA,mBAAA;IACA,aAAA;IACA,aAAA;EARN;EAUM;IACI,SAAA;EARV;EAUM;IACI,eAAA;IACA,iBAAA;IACA,YAAA;EARV;EAUM;IACI,eAAA;IACA,iBAAA;EARV;EAUM;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;EARV;EAUU;IACI,WAAA;IACA,YAAA;IAEA,mBAAA;EATd;EAYM;IACI,UAAA;IACA,WAAA;EAVV;EAWU;IACI,WAAA;IACA,YAAA;IACA,mBAAA;EATd;AACF;AAaA;EACI;IACI,YAAA;IACA,mBAAA;IACA,aAAA;IACA,aAAA;EAXN;EAaM;IACI,SAAA;EAXV;EAaM;IACI,eAAA;IACA,iBAAA;IACA,YAAA;EAXV;EAaM;IACI,eAAA;IACA,iBAAA;EAXV;EAaM;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;EAXV;EAaU;IACI,WAAA;IACA,YAAA;IAEA,mBAAA;EAZd;EAeM;IACI,UAAA;IACA,WAAA;EAbV;EAeU;IACI,WAAA;IACA,YAAA;IACA,mBAAA;EAbd;AACF;AAiBA;EACI;IACI,YAAA;IACA,mBAAA;IACA,aAAA;IACA,aAAA;EAfN;EAiBM;IACI,SAAA;EAfV;EAiBM;IACI,eAAA;IACA,iBAAA;IACA,YAAA;EAfV;EAiBM;IACI,eAAA;IACA,iBAAA;EAfV;EAiBM;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;EAfV;EAgBU;IACI,WAAA;IACA,YAAA;IACA,mBAAA;EAdd;EAiBM;IACI,UAAA;IACA,WAAA;EAfV;EAgBU;IACI,WAAA;IACA,YAAA;IACA,mBAAA;EAdd;AACF;AAmBA;EACI;IACI,YAAA;IACA,mBAAA;IACA,aAAA;IACA,aAAA;EAjBN;EAmBM;IACI,SAAA;EAjBV;EAmBM;IACI,eAAA;IACA,iBAAA;IACA,YAAA;EAjBV;EAmBM;IACI,eAAA;IACA,iBAAA;EAjBV;EAmBM;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;EAjBV;EAkBU;IACI,WAAA;IACA,YAAA;IAEA,mBAAA;EAjBd;EAoBM;IACI,UAAA;IACA,WAAA;EAlBV;EAoBU;IACI,WAAA;IACA,YAAA;IACA,mBAAA;EAlBd;AACF;AAuBA;EACI;IACI,YAAA;IACA,mBAAA;IACA,aAAA;IACA,aAAA;EArBN;EAuBM;IACI,SAAA;EArBV;EAuBM;IACI,eAAA;IACA,iBAAA;IACA,YAAA;EArBV;EAuBM;IACI,eAAA;IACA,iBAAA;EArBV;EAuBM;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;EArBV;EAsBU;IACI,WAAA;IACA,YAAA;IAEA,mBAAA;EArBd;EAwBM;IACI,UAAA;IACA,WAAA;EAtBV;EAwBU;IACI,WAAA;IACA,YAAA;IACA,mBAAA;EAtBd;AACF","sourcesContent":["@import '../../../Styles/sass/variables';\n\n.ModernCard {\n    background-color: $primary_light;\n    border-radius: 20px;\n    padding: 8px;\n    display: flex;\n    box-shadow: 0px 6px 16px 0px #00aa7430;\n    color: $color_black_200;\n    .header {\n        display: flex;\n        flex-direction: column;\n        gap: 32px;\n    }\n    .heading {\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 17px;\n        letter-spacing: 0em;\n    }\n\n    .subheading {\n        color: #00aa74;\n        font-size: 26px;\n        font-weight: 700;\n        line-height: 31px;\n        letter-spacing: 0.02em;\n    }\n    .icon {\n        align-self: end;\n        width: 30%;\n        height: 50%;\n        // background: #00aa74;\n    }\n    .icon1 {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 70px;\n        height: 70px;\n\n        img {\n            width: 100%;\n            height: 100%;\n\n            object-fit: contain;\n        }\n    }\n    .header-flex {\n        display: flex;\n        justify-content: space-between;\n    }\n    .header-flex-around {\n        display: flex;\n        justify-content: space-around;\n    }\n\n    .subheading-container {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .subheading-wrapper {\n        width: 50%;\n    }\n}\n\n.modern-custom-class {\n    background: #e6f7ef;\n}\n\n.HomeView--treeIcon {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 2rem;\n    background: linear-gradient(225deg, #bae897 0%, #bbfbdd 100%);\n}\n@media (min-height: 600px) {\n    .ModernCard {\n        padding: 4px;\n        border-radius: 12px;\n        height: 125px;\n        display: flex;\n        .header {\n            gap: 12px;\n        }\n        .heading {\n            font-size: 13px;\n            line-height: 14px;\n            width: '50%';\n        }\n        .subheading {\n            font-size: 18px;\n            line-height: 22px;\n        }\n        .icon1 {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 40px;\n            height: 40px;\n            img {\n                width: 100%;\n                height: 100%;\n\n                object-fit: contain;\n            }\n        }\n        .icon {\n            width: 40%;\n            height: 60%;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: contain;\n            }\n        }\n    }\n}\n@media (min-height: 700px) {\n    .ModernCard {\n        padding: 4px;\n        border-radius: 12px;\n        height: 145px;\n        display: flex;\n\n        .header {\n            gap: 12px;\n        }\n        .heading {\n            font-size: 13px;\n            line-height: 14px;\n            width: '50%';\n        }\n        .subheading {\n            font-size: 18px;\n            line-height: 22px;\n        }\n        .icon1 {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 45px;\n            height: 45px;\n\n            img {\n                width: 100%;\n                height: 100%;\n\n                object-fit: contain;\n            }\n        }\n        .icon {\n            width: 45%;\n            height: 65%;\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: contain;\n            }\n        }\n    }\n}\n@media (min-height: 800px) {\n    .ModernCard {\n        padding: 4px;\n        border-radius: 12px;\n        height: 180px;\n        display: flex;\n\n        .header {\n            gap: 12px;\n        }\n        .heading {\n            font-size: 14px;\n            line-height: 14px;\n            width: '50%';\n        }\n        .subheading {\n            font-size: 20px;\n            line-height: 22px;\n        }\n        .icon1 {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 60px;\n            height: 60px;\n\n            img {\n                width: 100%;\n                height: 100%;\n\n                object-fit: contain;\n            }\n        }\n        .icon {\n            width: 40%;\n            height: 60%;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: contain;\n            }\n        }\n    }\n}\n@media screen and (min-width: 400px) and (min-height: 800px) {\n    .ModernCard {\n        padding: 4px;\n        border-radius: 12px;\n        height: 207px;\n        display: flex;\n\n        .header {\n            gap: 12px;\n        }\n        .heading {\n            font-size: 16px;\n            line-height: 18px;\n            width: '50%';\n        }\n        .subheading {\n            font-size: 22px;\n            line-height: 24px;\n        }\n        .icon1 {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 70px;\n            height: 70px;\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: contain;\n            }\n        }\n        .icon {\n            width: 40%;\n            height: 70%;\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: contain;\n            }\n        }\n    }\n}\n\n@media screen and (min-width: 420px) and (min-height: 900px) {\n    .ModernCard {\n        padding: 4px;\n        border-radius: 12px;\n        height: 225px;\n        display: flex;\n\n        .header {\n            gap: 12px;\n        }\n        .heading {\n            font-size: 18px;\n            line-height: 20px;\n            width: '50%';\n        }\n        .subheading {\n            font-size: 24px;\n            line-height: 26px;\n        }\n        .icon1 {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 80px;\n            height: 80px;\n            img {\n                width: 100%;\n                height: 100%;\n\n                object-fit: contain;\n            }\n        }\n        .icon {\n            width: 40%;\n            height: 80%;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: contain;\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 420px) and (min-height: 900px) {\n    .ModernCard {\n        padding: 4px;\n        border-radius: 12px;\n        height: 217px;\n        display: flex;\n\n        .header {\n            gap: 12px;\n        }\n        .heading {\n            font-size: 18px;\n            line-height: 20px;\n            width: '50%';\n        }\n        .subheading {\n            font-size: 24px;\n            line-height: 26px;\n        }\n        .icon1 {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 75px;\n            height: 75px;\n            img {\n                width: 100%;\n                height: 100%;\n\n                object-fit: contain;\n            }\n        }\n        .icon {\n            width: 40%;\n            height: 80%;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: contain;\n            }\n        }\n    }\n}\n","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
